import { useTranslation } from 'react-i18n-lite'

import { useSelector } from 'react-redux'

import { useParams, useSearchParams } from 'react-router-dom'

import { AuthenticationType } from 'authentication/shared/types'

import Iframe from 'shared/components/Iframe'

import useWorkflow from 'workflow/shared/hooks/useWorkflow'
import useIframe from 'interaction/Embed/hooks/useIframe'
import ProcessExecutionState, {
  OutputTaskHandler
} from 'workflow/shared/types/processExecutionState.type'
import { LoadingPage } from '@yes.technology/react-toolkit'

type Params = {
  readonly workflowUuid: string
  readonly taskUuid: string
}

const OutputTask = () => {
  const { language } = useTranslation()

  const { workflowUuid = '', taskUuid = '' } = useParams<Params>()

  const [searchParams] = useSearchParams()
  const hideInteractionContainer =
    searchParams.has('hideInteractionContainer') ?? false

  const urlInteraction = window.waInteractionUrl

  const token = useSelector(
    ({ authentication }: AuthenticationType) => authentication.token
  )

  const { workflow, isFetching } = useWorkflow({ workflowUuid })

  const rawExecutionState = workflow?.execution_state || 'null'
  const executionState = JSON.parse(rawExecutionState) as ProcessExecutionState

  const nodes = executionState?.nodes || []

  const outputTaskNode = nodes.find(({ uuid }) => uuid === taskUuid)
  const { nodemodel_uuid: outputNodemodelUuid } = outputTaskNode || {}

  const nodeModels = executionState?.flow_elementmodels?.nodemodels || []

  const outputNodeModel = nodeModels.find(
    ({ uuid }) => uuid === outputNodemodelUuid
  )

  const outputActionHandler = outputNodeModel?.handler as OutputTaskHandler
  const interactionModelUuid = outputActionHandler?.interactionmodel_uuid
  const targetContainerVariable = outputActionHandler?.target_container_variable

  const queryParams = new URLSearchParams({
    token,
    lang: language,
    uuid_workflow: workflowUuid,
    processValuesVariable: targetContainerVariable || '',
    ...(hideInteractionContainer && { hideInteractionContainer: 'true' })
  })

  const queryString = queryParams.toString()

  const iframeSrc = `${urlInteraction}${interactionModelUuid}?${queryString}`

  const { iframeAttributes } = useIframe({
    origin: urlInteraction,
    src: iframeSrc,
    title: 'Interaction',
    name: 'interaction'
  })

  if (isFetching) {
    return <LoadingPage />
  }

  return (
    <Iframe {...iframeAttributes} allow='camera; geolocation; microphone' />
  )
}

export default OutputTask
